import * as actionTypes from "../actionTypes";

const initialState = {
  currentSessionId: "",
  openSessions: [],
  persistIn: "session"
};

export default function sessionReducer(state = initialState, action) {
  let data = action.data;
  switch (action.type) {
    case actionTypes.SET_CURRENT_SESSION:
      return {
        ...state,
        currentSessionId: data,
      };
    case actionTypes.ADD_SESSION:
      return {
        ...state,
        openSessions: [
          ...state.openSessions,
          {
            id: data.newId,
            displayName: data.newDisplayName,
            dataSegmentId: data.newDataSegmentId,
            originUri: data.newOriginUri,
            closeDestinationUri: data.newCloseDestinationUri,
            taskDisplayName: data.newTaskDisplayName,
            taskId: data.newTaskId,
            isWorkspace: data.newIsWorkspace,
          }
        ]
      };
    case actionTypes.UPDATE_SESSION: {
      let existingIndex = state.openSessions.findIndex(item => item && item.id === data.sessionId);
      let all = [...state.openSessions];
      all[existingIndex] = { ...all[existingIndex], ...data };
      return {
        ...state,
        openSessions: [...all]
      };
    }
    case actionTypes.UPDATE_SESSION_VIEWPORTS: {
      let existingIndex = state.openSessions.findIndex(item => item && item.id === data.sessionId);
      let all = [...state.openSessions];
      all[existingIndex] = { ...all[existingIndex], viewports: data.viewports };
      return {
        ...state,
        openSessions: [...all]
      };
    }
    case actionTypes.REMOVE_SESSION:
      return {
        ...state,
        openSessions: state.openSessions.filter(item => item && item.id !== data)
      };
    case actionTypes.CLEAR_SESSIONS:
      return initialState;
    default:
      return state;
  }
}
